export const toArray = element => ((Array.isArray(element) && element) || [element]);

export const hash = (length = 8) => Math.round(Math.random() * Math.pow(10, length)).toString(36);

export const normalizeNL = str => (!str ? str : str.replace(/\r\n|\r/g, '\n'));

export const shortLink = url => url.replace(/(https?)?:\/\//, '').split('/')[0];
